import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from './confirm-dialog';

export function openLogoutConfirmationDialog(
  dialog: MatDialog
): Observable<boolean> {
  return dialog
    .open(ConfirmDialogComponent, {
      data: {
        title: 'Sair da conta',
        message: 'Tem certeza que deseja sair?',
        confirmText: 'Sair',
        cancelText: 'Cancelar',
      } as ConfirmDialogData,
    })
    .afterClosed()
    .pipe(map((confirmed) => confirmed === true));
}
